const state = {
  token: JSON.parse(localStorage.getItem("KB_token")) || "",
  form: {},
};

const getters = {};

const mutations = {
  SAVE_USER(state, details) {
    state.token = details.token;
    localStorage.setItem("KB_token", JSON.stringify(details.token));
  },
  SAVE_CREDENTIAL(state, details) {
    state.form = details;
  },
  LOGOUT(state) {
    state.token = "";
    localStorage.clear();
    window.location.href = "/login";
  },
};

const actions = {};

export default {
  namedspaced: true,
  state,
  getters,
  mutations,
  actions,
};
